import { paths } from 'src/routes/paths';

/**
 * Resolve the in-app deep-link path for a notification.
 * Returns null when the notification has no actionable target — callers
 * should fall back to a no-op (e.g., just mark-as-read).
 */
export function getDeepLinkForNotification(notification) {
  if (!notification) return null;

  const metadata = notification.metadata || {};
  const entityType = metadata.entity_type;
  const entityId = metadata.entity_id;

  if (!entityType || !entityId) return null;

  switch (entityType) {
    case 'FACILITY_RESERVATION':
      return paths.dashboard.bookings.details(entityId);
    case 'SESSION':
      return paths.dashboard.sessions.details(entityId);
    case 'RECURRING_SESSION':
      return paths.dashboard.sessions.recurring.details(entityId);
    case 'PAYMENT':
      return paths.dashboard.payments.details(entityId);
    default:
      return null;
  }
}
